import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseUrl = `${process.env.REACT_APP_BACKEND_URL}`;

export const api = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth?.token;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
    timeout: 60000, // 60 seconds default timeout
  }),
  tagTypes: [
    'User',
    'Auth',
    'Client',
    'ClientList',
    'Dashboard',
    'Settings',
    'Notifications',
    'Invoices',
    'ApiConnections',
    'BillingHistory',
    'PaymentMethod',
  ],
  endpoints: () => ({}),
});

export default api;
